import { render } from "./NewSetXRM.vue?vue&type=template&id=1e4ad372"
import script from "./NewSetXRM.vue?vue&type=script&lang=js"
export * from "./NewSetXRM.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__